module.exports = __webpack_public_path__ + "img/ccb45a2.png";